(function () {
  'use strict';

  var DARK_ZONE_IDS = [
    'shopify-section-1498163293234',
    'shopify-section-16265000899d8322bc',
    'shopify-section-1627087923be2746e4'
  ];

  var WHITE_SECTION_ID = 'shopify-section-1626493556d16d6e6f';

  var MIN_H = 400;
  var MAX_H = 2800;

  var canvases = document.querySelectorAll('[data-eastdtc-canvas]');
  if (!canvases.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canvasResize = window.EastDtcCanvasResize;
  var mainEl = document.querySelector('.template-index .main-content');

  canvases.forEach(function (canvas) {
    initCanvas(canvas);
  });

  function measureDarkZoneHeight() {
    if (!mainEl) return 900;

    var mainTop = mainEl.getBoundingClientRect().top;
    var whiteSection = document.getElementById(WHITE_SECTION_ID);

    if (whiteSection) {
      var junction = Math.ceil(whiteSection.getBoundingClientRect().top - mainTop);
      if (junction > 0) {
        return Math.min(MAX_H, Math.max(MIN_H, junction));
      }
    }

    var first = document.getElementById(DARK_ZONE_IDS[0]);
    var last = document.getElementById(DARK_ZONE_IDS[DARK_ZONE_IDS.length - 1]);
    if (first && last) {
      var span = Math.ceil(last.getBoundingClientRect().bottom - mainTop);
      if (span > 0) return Math.min(MAX_H, Math.max(MIN_H, span));
    }

    return 900;
  }

  function initCanvas(canvas) {
    var wrap = canvas.closest('.home-canvas-hero, .eastdtc-starfield, .eastdtc-footer-canvas');
    if (!wrap) return;

    var canvasMode = wrap.getAttribute('data-canvas-mode') || 'fill';
    if (canvasMode === 'hero' && !mainEl) return;
    var isFooter = canvasMode === 'footer';

    var ctx = canvas.getContext('2d', { alpha: false });
    var accent = parseColor(wrap.getAttribute('data-accent') || '#e60012');
    var starDensity = parseInt(wrap.getAttribute('data-particle-count') || '80', 10);

    var width = 0;
    var height = 0;
    var dpr = 1;
    var rafId = null;
    var running = false;
    var layoutTimer = null;
    var tabLayout = canvasResize ? canvasResize.createLayoutScheduler(runLayoutFromScheduler) : null;

    var stars = [];
    var nebulae = [];
    var seaWaves = [];
    var shootingStars = [];
    var earthNodes = [];
    var time = 0;
    var VIEW_TILT = 0.48;

    function parseColor(hex) {
      var h = hex.replace('#', '');
      if (h.length === 3) {
        h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      }
      return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16)
      };
    }

    function applyCanvasHeight() {
      if (canvasMode === 'hero' && mainEl) {
        var nextHeight = measureDarkZoneHeight();
        mainEl.style.setProperty('--home-canvas-h', nextHeight + 'px');
      }
      resize();
    }

    function sizeContainer() {
      if (isFooter) {
        return wrap.closest('.site-footer') || wrap;
      }
      if (canvasMode === 'hero' && mainEl) {
        return mainEl;
      }
      return wrap;
    }

    function measureWrapSize() {
      var container = sizeContainer();
      var opts = {
        minWidth: 80,
        minHeight: 80,
        fallbackViewportWidth: canvasMode !== 'footer',
        fallbackViewportHeightRatio: canvasMode !== 'hero' && !isFooter ? 0.35 : 0
      };

      if (canvasResize) {
        return canvasResize.measureCanvasSize(canvas, container, opts);
      }

      var cw = Math.floor(canvas.clientWidth);
      var ch = Math.floor(canvas.clientHeight);
      if (cw >= 80 && ch >= 80) {
        return { width: cw, height: ch };
      }

      var rect = container.getBoundingClientRect();
      return {
        width: Math.max(1, Math.floor(rect.width) || container.offsetWidth || 1),
        height: Math.max(1, Math.floor(rect.height) || container.offsetHeight || 1)
      };
    }

    function resize() {
      var size = measureWrapSize();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = size.width;
      height = size.height;
      if (height > MAX_H) height = MAX_H;

      if (canvasResize) {
        canvasResize.applyCanvasDisplaySize(canvas);
      } else {
        canvas.style.width = '100%';
        canvas.style.height = '100%';
      }

      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
    }

    function resizeIfNeeded() {
      if (canvasResize && !canvasResize.canvasNeedsResize(canvas, width, height, dpr)) {
        return false;
      }
      var size = measureWrapSize();
      if (
        Math.abs(size.width - width) <= 2 &&
        Math.abs(size.height - height) <= 2 &&
        canvas.width > 0
      ) {
        return false;
      }
      resize();
      return true;
    }

    function seed() {
      stars = [];
      nebulae = [];
      seaWaves = [];
      shootingStars = [];

      var areaScale = Math.sqrt((width * height) / (1440 * 900));
      var count = Math.round(starDensity * areaScale * 2.2);
      count = Math.max(120, Math.min(count, 420));

      for (var i = 0; i < count; i++) {
        var layer = Math.random();
        var isBright = Math.random() < 0.04;
        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: isBright ? Math.random() * 1.8 + 1.2 : Math.random() * 1.2 + 0.2,
          baseA: isBright ? 0.75 + Math.random() * 0.25 : 0.15 + Math.random() * 0.55,
          twinkle: Math.random() * Math.PI * 2,
          twinkleSpeed: 0.008 + Math.random() * 0.02,
          driftX: (Math.random() - 0.5) * (layer < 0.3 ? 0.02 : 0.06),
          driftY: (Math.random() - 0.5) * 0.02,
          hue: Math.random() < 0.12 ? 'warm' : Math.random() < 0.25 ? 'blue' : 'white',
          flare: isBright && Math.random() < 0.35
        });
      }

      nebulae = [
        { x: width * 0.22, y: height * 0.2, r: Math.min(width, height) * 0.42, phase: 0, tone: 'violet' },
        { x: width * 0.72, y: height * 0.35, r: Math.min(width, height) * 0.36, phase: 1.8, tone: 'blue' },
        { x: width * 0.48, y: height * 0.55, r: Math.min(width, height) * 0.28, phase: 2.6, tone: 'blue' },
        { x: width * 0.6, y: height * 0.78, r: Math.min(width, height) * 0.26, phase: 3.2, tone: 'accent' }
      ];

      if (!isFooter) {
        for (var w = 0; w < 5; w++) {
          seaWaves.push({
            yBase: height * (0.9 + w * 0.018),
            amplitude: 8 + w * 3,
            length: 0.004 + w * 0.0015,
            speed: 0.35 + w * 0.12,
            phase: Math.random() * Math.PI * 2,
            opacity: 0.06 - w * 0.008
          });
        }
      }

      earthNodes = [];
      if (isFooter) {
        for (var n = 0; n < 320; n++) {
          earthNodes.push({
            lat: -25 + Math.random() * 95,
            lon: Math.random() * 360,
            pulse: Math.random() * Math.PI * 2,
            accent: Math.random() < 0.1
          });
        }
      }
    }

    function spawnShootingStar() {
      if (shootingStars.length > 2 || Math.random() > 0.012) return;
      var fromLeft = Math.random() > 0.5;
      shootingStars.push({
        x: fromLeft ? Math.random() * width * 0.3 : width * 0.7 + Math.random() * width * 0.3,
        y: Math.random() * height * 0.35,
        len: 60 + Math.random() * 90,
        speed: 6 + Math.random() * 8,
        angle: fromLeft ? Math.PI * 0.22 + Math.random() * 0.12 : Math.PI * 0.78 - Math.random() * 0.12,
        life: 1
      });
    }

    function drawCosmicSky(t) {
      var sky = ctx.createLinearGradient(0, 0, 0, height);
      sky.addColorStop(0, '#020208');
      sky.addColorStop(0.35, '#060818');
      sky.addColorStop(0.65, '#0a0e1e');
      sky.addColorStop(0.88, '#08122a');
      sky.addColorStop(1, '#040a14');
      ctx.fillStyle = sky;
      ctx.fillRect(0, 0, width, height);

      var horizonY = height * 0.9;
      var seaGrad = ctx.createLinearGradient(0, horizonY, 0, height);
      seaGrad.addColorStop(0, 'rgba(12, 28, 58, 0.25)');
      seaGrad.addColorStop(0.5, 'rgba(6, 18, 42, 0.45)');
      seaGrad.addColorStop(1, 'rgba(2, 6, 14, 0.65)');
      ctx.fillStyle = seaGrad;
      ctx.fillRect(0, horizonY, width, height - horizonY);

      nebulae.forEach(function (n) {
        var pulse = 0.85 + Math.sin(t * 0.0004 + n.phase) * 0.15;
        var nx = n.x + Math.sin(t * 0.00025 + n.phase) * width * 0.02;
        var ny = n.y + Math.cos(t * 0.0002 + n.phase) * height * 0.015;
        var nr = n.r * pulse;
        var neb = ctx.createRadialGradient(nx, ny, 0, nx, ny, nr);

        if (n.tone === 'accent') {
          neb.addColorStop(0, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.14)');
          neb.addColorStop(0.4, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.05)');
        } else if (n.tone === 'violet') {
          neb.addColorStop(0, 'rgba(88, 56, 168, 0.16)');
          neb.addColorStop(0.45, 'rgba(40, 24, 80, 0.06)');
        } else {
          neb.addColorStop(0, 'rgba(32, 72, 168, 0.14)');
          neb.addColorStop(0.45, 'rgba(16, 40, 96, 0.05)');
        }
        neb.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = neb;
        ctx.fillRect(0, 0, width, height);
      });

      var pathGlow = ctx.createLinearGradient(width * 0.1, height * 0.5, width * 0.9, height * 0.35);
      pathGlow.addColorStop(0, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0)');
      pathGlow.addColorStop(0.45, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.06)');
      pathGlow.addColorStop(0.7, 'rgba(255, 200, 120, 0.04)');
      pathGlow.addColorStop(1, 'rgba(80, 160, 255, 0.05)');
      ctx.fillStyle = pathGlow;
      ctx.fillRect(0, 0, width, height);
    }

    function drawSeaWaves(t) {
      seaWaves.forEach(function (wave) {
        ctx.beginPath();
        var baseY = wave.yBase + Math.sin(t * 0.0003 + wave.phase) * 6;
        ctx.moveTo(0, baseY);
        for (var x = 0; x <= width; x += 4) {
          var y = baseY + Math.sin(x * wave.length + t * 0.001 * wave.speed + wave.phase) * wave.amplitude;
          ctx.lineTo(x, y);
        }
        ctx.lineTo(width, height);
        ctx.lineTo(0, height);
        ctx.closePath();
        ctx.fillStyle = 'rgba(40, 100, 180, ' + wave.opacity + ')';
        ctx.fill();
      });

      var shimmer = ctx.createLinearGradient(0, height * 0.82, width, height * 0.88);
      shimmer.addColorStop(0, 'rgba(255,255,255,0)');
      shimmer.addColorStop(0.5, 'rgba(120, 180, 255, 0.04)');
      shimmer.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = shimmer;
      ctx.fillRect(0, height * 0.88, width, height * 0.12);
    }

    function starColor(star, alpha) {
      if (star.hue === 'warm') {
        return 'rgba(255, 210, 180, ' + alpha + ')';
      }
      if (star.hue === 'blue') {
        return 'rgba(180, 210, 255, ' + alpha + ')';
      }
      return 'rgba(255, 255, 255, ' + alpha + ')';
    }

    function drawStars(t) {
      stars.forEach(function (star) {
        star.x += star.driftX;
        star.y += star.driftY;
        if (star.x < 0) star.x = width;
        if (star.x > width) star.x = 0;
        if (star.y < 0) star.y = height;
        if (star.y > height) star.y = 0;

        var twinkle = 0.55 + 0.45 * Math.sin(t * star.twinkleSpeed + star.twinkle);
        var a = star.baseA * twinkle;

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = starColor(star, a);
        ctx.fill();

        if (star.flare) {
          ctx.strokeStyle = starColor(star, a * 0.35);
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(star.x - star.r * 4, star.y);
          ctx.lineTo(star.x + star.r * 4, star.y);
          ctx.moveTo(star.x, star.y - star.r * 4);
          ctx.lineTo(star.x, star.y + star.r * 4);
          ctx.stroke();
        }
      });
    }

    function drawShootingStars() {
      shootingStars = shootingStars.filter(function (s) {
        s.x += Math.cos(s.angle) * s.speed;
        s.y += Math.sin(s.angle) * s.speed;
        s.life -= 0.018;

        if (s.life <= 0) return false;

        var grad = ctx.createLinearGradient(
          s.x, s.y,
          s.x - Math.cos(s.angle) * s.len,
          s.y - Math.sin(s.angle) * s.len
        );
        grad.addColorStop(0, 'rgba(255, 255, 255, ' + (s.life * 0.9) + ')');
        grad.addColorStop(0.35, 'rgba(200, 220, 255, ' + (s.life * 0.5) + ')');
        grad.addColorStop(1, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ', 0)');

        ctx.strokeStyle = grad;
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(s.x, s.y);
        ctx.lineTo(s.x - Math.cos(s.angle) * s.len, s.y - Math.sin(s.angle) * s.len);
        ctx.stroke();
        return true;
      });
    }

    function drawVignette() {
      var focusY = isFooter ? height * 0.42 : height * 0.38;
      var vignette = ctx.createRadialGradient(
        width * 0.5, focusY, width * 0.05,
        width * 0.5, focusY + height * 0.08, Math.max(width, height) * 0.9
      );
      vignette.addColorStop(0, 'rgba(255,255,255,0.02)');
      vignette.addColorStop(1, 'rgba(0,0,0,0.28)');
      ctx.fillStyle = vignette;
      ctx.fillRect(0, 0, width, height);
    }

    function drawNebulaeLayer(t) {
      nebulae.forEach(function (n) {
        var pulse = 0.85 + Math.sin(t * 0.0004 + n.phase) * 0.15;
        var nx = n.x + Math.sin(t * 0.00025 + n.phase) * width * 0.02;
        var ny = n.y + Math.cos(t * 0.0002 + n.phase) * height * 0.015;
        var nr = n.r * pulse;
        var neb = ctx.createRadialGradient(nx, ny, 0, nx, ny, nr);

        if (n.tone === 'accent') {
          neb.addColorStop(0, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.14)');
          neb.addColorStop(0.4, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.05)');
        } else if (n.tone === 'violet') {
          neb.addColorStop(0, 'rgba(88, 56, 168, 0.16)');
          neb.addColorStop(0.45, 'rgba(40, 24, 80, 0.06)');
        } else {
          neb.addColorStop(0, 'rgba(32, 72, 168, 0.14)');
          neb.addColorStop(0.45, 'rgba(16, 40, 96, 0.05)');
        }
        neb.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = neb;
        ctx.fillRect(0, 0, width, height);
      });
    }

    function drawFooterSpace(t) {
      var sky = ctx.createLinearGradient(0, 0, 0, height);
      sky.addColorStop(0, '#010106');
      sky.addColorStop(0.45, '#040818');
      sky.addColorStop(0.75, '#06102a');
      sky.addColorStop(1, '#030810');
      ctx.fillStyle = sky;
      ctx.fillRect(0, 0, width, height);

      var pathGlow = ctx.createLinearGradient(width * 0.15, 0, width * 0.85, height * 0.55);
      pathGlow.addColorStop(0, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0)');
      pathGlow.addColorStop(0.5, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.05)');
      pathGlow.addColorStop(1, 'rgba(80, 160, 255, 0.04)');
      ctx.fillStyle = pathGlow;
      ctx.fillRect(0, 0, width, height);
    }

    function earthProject(latDeg, lonDeg, rotY, cx, cy, R) {
      var phi = latDeg * Math.PI / 180;
      var lam = lonDeg * Math.PI / 180 + rotY;
      var x = Math.cos(phi) * Math.sin(lam);
      var y = Math.sin(phi);
      var z = Math.cos(phi) * Math.cos(lam);
      var cosT = Math.cos(VIEW_TILT);
      var sinT = Math.sin(VIEW_TILT);
      var yv = y * cosT + z * sinT;
      var zv = -y * sinT + z * cosT;

      if (zv < 0.04) return null;

      var persp = 1 / (1 + zv * 0.32);
      return {
        x: cx + x * R * persp,
        y: cy - yv * R * persp,
        depth: zv
      };
    }

    function drawDigitizedEarth(t) {
      var cx = width * 0.5;
      var cy = height * 1.06;
      var R = Math.min(width, height) * 0.58;
      var rotY = t * 0.00014;

      var glow = ctx.createRadialGradient(cx, cy - R * 0.42, R * 0.05, cx, cy - R * 0.42, R * 1.15);
      glow.addColorStop(0, 'rgba(40, 120, 220, 0.22)');
      glow.addColorStop(0.35, 'rgba(20, 60, 140, 0.1)');
      glow.addColorStop(0.7, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.04)');
      glow.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, width, height);

      function strokeLatLine(lat, alpha, widthPx) {
        ctx.beginPath();
        var open = false;
        for (var lon = 0; lon <= 360; lon += 3) {
          var p = earthProject(lat, lon, rotY, cx, cy, R);
          if (!p) {
            open = false;
            continue;
          }
          if (!open) {
            ctx.moveTo(p.x, p.y);
            open = true;
          } else {
            ctx.lineTo(p.x, p.y);
          }
        }
        ctx.strokeStyle = 'rgba(72, 168, 255, ' + alpha + ')';
        ctx.lineWidth = widthPx;
        ctx.stroke();
      }

      function strokeLonLine(lon, alpha, widthPx) {
        ctx.beginPath();
        var open = false;
        for (var lat = -75; lat <= 90; lat += 3) {
          var p = earthProject(lat, lon, rotY, cx, cy, R);
          if (!p) {
            open = false;
            continue;
          }
          if (!open) {
            ctx.moveTo(p.x, p.y);
            open = true;
          } else {
            ctx.lineTo(p.x, p.y);
          }
        }
        ctx.strokeStyle = 'rgba(72, 168, 255, ' + alpha + ')';
        ctx.lineWidth = widthPx;
        ctx.stroke();
      }

      for (var lat = -30; lat <= 90; lat += 10) {
        strokeLatLine(lat, lat % 20 === 0 ? 0.32 : 0.16, lat % 20 === 0 ? 0.9 : 0.55);
      }
      for (var lon = 0; lon < 360; lon += 10) {
        var isAccentMeridian = lon % 30 === 0;
        if (isAccentMeridian) {
          ctx.beginPath();
          var lonOpen = false;
          for (var latA = -75; latA <= 90; latA += 3) {
            var pa = earthProject(latA, lon, rotY, cx, cy, R);
            if (!pa) {
              lonOpen = false;
              continue;
            }
            if (!lonOpen) {
              ctx.moveTo(pa.x, pa.y);
              lonOpen = true;
            } else {
              ctx.lineTo(pa.x, pa.y);
            }
          }
          ctx.strokeStyle = 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.42)';
          ctx.lineWidth = 1;
          ctx.stroke();
        } else {
          strokeLonLine(lon, 0.14, 0.55);
        }
      }

      earthNodes.forEach(function (node) {
        var p = earthProject(node.lat, node.lon, rotY, cx, cy, R);
        if (!p || p.depth < 0.12) return;
        var tw = 0.45 + 0.55 * Math.sin(t * 0.002 + node.pulse);
        var a = (0.15 + p.depth * 0.55) * tw;
        var r = 0.6 + p.depth * 1.1;
        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        if (node.accent) {
          ctx.fillStyle = 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',' + a + ')';
        } else {
          ctx.fillStyle = 'rgba(120, 220, 255, ' + a + ')';
        }
        ctx.fill();
      });

      ctx.beginPath();
      var rimOpen = false;
      for (var rimLon = 0; rimLon <= 360; rimLon += 2) {
        var rimP = earthProject(-8, rimLon, rotY, cx, cy, R);
        if (!rimP) {
          rimOpen = false;
          continue;
        }
        if (!rimOpen) {
          ctx.moveTo(rimP.x, rimP.y);
          rimOpen = true;
        } else {
          ctx.lineTo(rimP.x, rimP.y);
        }
      }
      var rimGrad = ctx.createLinearGradient(cx - R, cy - R, cx + R, cy);
      rimGrad.addColorStop(0, 'rgba(80, 180, 255, 0.45)');
      rimGrad.addColorStop(0.5, 'rgba(200, 230, 255, 0.65)');
      rimGrad.addColorStop(1, 'rgba(' + accent.r + ',' + accent.g + ',' + accent.b + ',0.35)');
      ctx.strokeStyle = rimGrad;
      ctx.lineWidth = 2;
      ctx.stroke();
    }

    function renderFooter(t) {
      drawFooterSpace(t);
      drawDigitizedEarth(t);
      drawNebulaeLayer(t);
      drawStars(t);
      spawnShootingStar();
      drawShootingStars();
      drawVignette();
    }

    function render(t) {
      time = t;
      if (isFooter) {
        renderFooter(t);
        return;
      }
      drawCosmicSky(t);
      drawSeaWaves(t);
      drawStars(t);
      spawnShootingStar();
      drawShootingStars();
      drawVignette();
    }

    function drawStatic() {
      render(0);
    }

    function frame(t) {
      if (!running) return;
      resizeIfNeeded();
      render(t);
      rafId = window.requestAnimationFrame(frame);
    }

    function start() {
      if (running || prefersReducedMotion) return;
      running = true;
      rafId = window.requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function runLayout() {
      applyCanvasHeight();
      if (canvasMode === 'fill') {
        revealStarfieldHeroText(wrap);
      }
      if (prefersReducedMotion) drawStatic();
    }

    function runLayoutFromScheduler(fromTabVisible) {
      runLayout();
      if (fromTabVisible && !prefersReducedMotion) start();
    }

    function scheduleLayout() {
      if (tabLayout) {
        tabLayout.schedule();
        return;
      }
      if (document.hidden) return;
      if (layoutTimer) window.clearTimeout(layoutTimer);
      layoutTimer = window.setTimeout(function () {
        layoutTimer = null;
        runLayout();
      }, 80);
    }

    function syncAfterTabVisible() {
      if (tabLayout) {
        tabLayout.syncWhenVisible();
        return;
      }
      runLayout();
      if (!prefersReducedMotion) start();
    }

    applyCanvasHeight();
    if (canvasMode === 'fill') {
      revealStarfieldHeroText(wrap);
    }

    if (!prefersReducedMotion) {
      start();
    } else {
      drawStatic();
    }

    function revealStarfieldHeroText(canvasWrap) {
      var hero = canvasWrap.closest('.hero--eastdtc-starfield');
      if (!hero) return;

      hero.classList.add('loaded', 'aos-animate', 'eastdtc-starfield--ready');
      hero.classList.remove('loading', 'loading--delayed');

      window.setTimeout(function () {
        hero.classList.add('aos-animate');
        var slides = hero.querySelectorAll('.slideshow__slide');
        slides.forEach(function (slide) {
          slide.classList.add('slick-current');
        });
      }, 100);
    }

    window.addEventListener('resize', scheduleLayout);
    window.addEventListener('load', scheduleLayout);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleLayout);
    }

    if (canvasMode === 'hero') {
      DARK_ZONE_IDS.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || !window.ResizeObserver) return;
        var ro = new ResizeObserver(scheduleLayout);
        ro.observe(el);
      });

      var whiteEl = document.getElementById(WHITE_SECTION_ID);
      if (whiteEl && window.ResizeObserver) {
        var whiteRo = new ResizeObserver(scheduleLayout);
        whiteRo.observe(whiteEl);
      }

      window.setTimeout(scheduleLayout, 400);
      window.setTimeout(scheduleLayout, 1200);
    } else if (isFooter && window.ResizeObserver) {
      var footerRo = new ResizeObserver(scheduleLayout);
      footerRo.observe(wrap);
      var footerEl = wrap.closest('.site-footer');
      if (footerEl) footerRo.observe(footerEl);
    } else if (window.ResizeObserver) {
      var fillRo = new ResizeObserver(scheduleLayout);
      fillRo.observe(wrap);
      var heroParent = wrap.closest('.hero');
      if (heroParent) fillRo.observe(heroParent);
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', scheduleLayout);
      document.addEventListener('shopify:section:reorder', scheduleLayout);
    }

    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            resizeIfNeeded();
            start();
          } else {
            stop();
          }
        });
      }, { threshold: 0.02 });
      io.observe(wrap);
    }

    if (tabLayout) {
      tabLayout.bindLifecycle({
        onHidden: function () {
          if (!prefersReducedMotion) stop();
        },
        onVisible: function () {
          if (prefersReducedMotion) syncAfterTabVisible();
          else {
            stop();
            syncAfterTabVisible();
          }
        }
      });
    } else {
      document.addEventListener('visibilitychange', function () {
        if (prefersReducedMotion) {
          if (!document.hidden) syncAfterTabVisible();
          return;
        }
        if (document.hidden) stop();
        else syncAfterTabVisible();
      });
    }
  }
})();
